import React from "react";
import "../../Styles/Pages/radio.scss";

class Radio extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	insertHtmlElement(html) {
		return { __html: html };
	}

	componentDidMount() {
		if (!this.props.id) {
			this.setState({ id: `radio${Math.random()}${new Date().getSeconds()}` });
		}
	}

	render() {
		return (
			<div className="form-radio">
				<div
					className="radio-items"
					style={{ padding: this.props.padding || "" }}
				>
					<div className="form-check form-check-inline ">
						<input
							type="radio"
							id={this.props.id || this.state.id}
							name={this.props.name}
							className="radio__input"
							value={this.props.value}
							checked={this.props.checked}
							{...(this.props.onClick && { onClick: this.props.onClick })}
							onChange={this.props.radioChange || this.props.onChange}
							disabled={this.props.disabled}
						/>
						<label htmlFor={this.props.id} className="radio-items__label">
							<span
								className="radio-data"
								style={{
									display: "block",
								}}
							>
								<span
									dangerouslySetInnerHTML={this.insertHtmlElement(
										this.props.label,
									)}
								/>
							</span>
						</label>
					</div>
				</div>
			</div>
		);
	}
}

export default Radio;
